/* ============================================================
   Synergy gallery zoom / lightbox
   The custom synergy gallery has a magnifying-glass button
   (.synergy-gallery__zoom) that was never wired up. This script
   opens a full-screen viewer when the button or the main image
   is clicked. Click the image to zoom 2x, move the mouse to pan,
   arrows / arrow keys to change photos, Esc or x to close.
   Loaded from theme.liquid on product templates only.
   ============================================================ */
(() => {
  const style = document.createElement('style');
  style.textContent = `
    .synergy-gallery__slide.is-active img { cursor: zoom-in; }
    .sz-overlay { position: fixed; inset: 0; z-index: 2147483647; background: rgba(0,0,0,.92);
      display: none; align-items: center; justify-content: center; overflow: hidden; }
    .sz-overlay.is-open { display: flex; }
    .sz-overlay img { max-width: 95vw; max-height: 90vh; object-fit: contain; cursor: zoom-in;
      transition: transform .2s ease; user-select: none; }
    .sz-overlay.is-zoomed img { cursor: zoom-out; transform: scale(2.2); }
    .sz-btn { position: absolute; background: rgba(255,255,255,.15); color: #fff; border: 0;
      border-radius: 50%; width: 44px; height: 44px; font-size: 26px; line-height: 1; cursor: pointer; }
    .sz-btn:hover { background: rgba(255,255,255,.3); }
    .sz-btn:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }
    .sz-close { top: 16px; right: 16px; }
    .sz-prev { left: 16px; top: 50%; transform: translateY(-50%); }
    .sz-next { right: 16px; top: 50%; transform: translateY(-50%); }
    @media (prefers-reduced-motion: reduce) { .sz-overlay img { transition: none; } }
  `;
  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.className = 'sz-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Product image viewer');
  overlay.innerHTML = `
    <img alt="">
    <button class="sz-btn sz-close" aria-label="Close">&times;</button>
    <button class="sz-btn sz-prev" aria-label="Previous image">&#8249;</button>
    <button class="sz-btn sz-next" aria-label="Next image">&#8250;</button>`;
  document.body.appendChild(overlay);

  const big = overlay.querySelector('img');
  const prevBtn = overlay.querySelector('.sz-prev');
  const nextBtn = overlay.querySelector('.sz-next');

  let images = [];
  let index = 0;

  const srcOf = img => img.currentSrc || img.src || img.dataset.src || '';
  const hiRes = src => {
    try {
      const u = new URL(src, location.href);
      u.searchParams.set('width', '2000');
      return u.toString();
    } catch (e) {
      return src;
    }
  };

  function show(i) {
    index = (i + images.length) % images.length;
    big.src = hiRes(srcOf(images[index]));
    big.alt = images[index].alt || '';
    overlay.classList.remove('is-zoomed');
    big.style.transformOrigin = 'center';
  }

  function open() {
    images = [...document.querySelectorAll('.synergy-gallery__slide img')];
    if (!images.length) return;
    const active = document.querySelector('.synergy-gallery__slide.is-active img');
    prevBtn.style.display = nextBtn.style.display = images.length > 1 ? '' : 'none';
    show(Math.max(0, images.indexOf(active)));
    document.body.appendChild(overlay); // keep the viewer above chat widgets
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    overlay.querySelector('.sz-close').focus();
  }

  function close() {
    overlay.classList.remove('is-open', 'is-zoomed');
    document.documentElement.style.overflow = '';
  }

  // Open from the magnifying glass or the main image
  document.addEventListener('click', e => {
    if (e.target.closest('.synergy-gallery__zoom') ||
        e.target.closest('.synergy-gallery__slide.is-active img')) {
      e.preventDefault();
      open();
    }
  });

  // Click image to toggle 2x zoom; move mouse to pan
  const setOrigin = e => {
    big.style.transformOrigin =
      `${(e.offsetX / big.offsetWidth) * 100}% ${(e.offsetY / big.offsetHeight) * 100}%`;
  };
  big.addEventListener('click', e => {
    setOrigin(e);
    overlay.classList.toggle('is-zoomed');
  });
  big.addEventListener('mousemove', e => {
    if (overlay.classList.contains('is-zoomed')) setOrigin(e);
  });

  overlay.querySelector('.sz-close').addEventListener('click', close);
  prevBtn.addEventListener('click', () => show(index - 1));
  nextBtn.addEventListener('click', () => show(index + 1));
  overlay.addEventListener('click', e => {
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', e => {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });
})();